export default {"src":"/_next/static/media/bb.bd5e7986.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};